<template>
    <div class="project-item-wrapper project-Subitem-wrapper position-re">
        <div
            class="hover-bg-light-purple-v1 project-item border-radius-5-px cursor-pointer"
            :class="[{
                'bg-light-purple-v1' : (folder && $route.params.folderId === data.folderId && !$route.params.sprintId) || (!folder && $route.params.sprintId === (data.id ? data.id : data._id)),
                'bg-light-purple-v2' : (folder && $route.params.folderId === data.folderId && $route.params.sprintId),
            }]"
        >
            <div class="position-ab drop__arrow-div">
                <img @click.stop="$emit('change', data)" v-if="sprints && sprints.length && (sprints.filter(e=>(showArchived ? e.deletedStatusKey == 2 : !e.deletedStatusKey))).length && !data.deletedStatusKey" src="@/assets/images/svg/arrow_down_fill.svg" alt="" :style="`transform: rotateZ(${isExpanded ? '0' : '-90'}deg)`">
            </div>
            <div class="item-left" @click.stop.prevent="$emit('changeProject'),changeRoute()">
                <Spinner v-if="!folder" :isSpinner="spinner" class="position-re list-spinner"/>

                <div class="text-ellipsis">
                    <img v-if="!folder"  :src="sprintIcon" alt="sprintIcon" class="mr-10px folder-icon">

                    <img v-if="data.deletedStatusKey !== undefined && data.deletedStatusKey === 2" :src="inventoryIcon" alt="inventoryIcon">
                    <img v-else-if="data.deletedStatusKey !== undefined && data.deletedStatusKey === 1" :src="deleteIcon" alt="deleteIcon">
                    <img v-if="folder" :src="folderIcon" alt="folderIcon" class="ml-6px folder-icon">
                    <span v-else>
                        <img v-if="!isShowArchived" @click.stop="markFavourite()" :src="localFavourite ? filledStar : blankStar" alt="favourite star" class="ml-6px project-favourite-pin">
                    </span>

                    <span class="text-ellipsis project-sb-desc ml-6px" :title="data.name">
                       {{data.name}}
                    </span>
                </div>
            </div>
            <div class="item-right">
                <template v-if="!isOpened">
                    <span v-if="!folder && !isShowArchived" class="gray sptint-total" :class="{'font-size-13': clientWidth > 767, 'font-size-16': clientWidth <= 767}">{{showArchived ? (data.archiveTaskCount || 0) : ((data.tasks < 0 ? 0 : data.tasks) || 0)}}</span>
                    <div class="count-block secondary-count-block child-count-block ml-6px" v-if="folder && data?.sprintsObj && Object.keys(data?.sprintsObj).length && showCounts({project, key: 'folder', sprints: Object.values(data?.sprintsObj), showArchived}).count" :style="({project, key: 'folder', sprints: Object.values(data?.sprintsObj), showArchived}).styles ">
                        {{showCounts({project, key: 'folder', sprints: Object.values(data?.sprintsObj), showArchived}).count > 99 ? "+99" : showCounts({project, key: 'folder', sprints: Object.values(data?.sprintsObj), showArchived}).count}}
                    </div>
                    <div class="count-block secondary-count-block child-count-block ml-6px" v-else-if="!folder && showCounts({project, key: 'sprint', sprints: [data], showArchived}).count" :style="({project, key: 'sprint', sprints: [data], showArchived}).styles">
                        {{showCounts({project, key: 'sprint', sprints: [data], showArchived}).count > 99 ? "+99" : showCounts({project, key: 'sprint', sprints: [data], showArchived}).count}}
                    </div>
                </template>
                <DropDown :id="itemId" @isVisible="(val)=> isOpened = val" :title="folder? data.name : data.name" v-if="
                    (
                        (folder && checkPermission('project.project_sprint_create',project.isGlobalPermission) === true)
                        || (folder && checkPermission('project.project_folder_name_edit',project.isGlobalPermission) === true)
                        || (!folder && checkPermission('project.project_sprint_name_edit',project.isGlobalPermission) === true)
                        || (folder && checkPermission('project.folder_delete',project.isGlobalPermission) === true)
                        || (!folder && checkPermission('project.sprint_delete',project.isGlobalPermission) === true)
                        || (folder && checkPermission('project.folder_restore',project.isGlobalPermission) === true && showArchived)
                        || (!folder && checkPermission('project.sprint_restore',project.isGlobalPermission) === true && showArchived)
                        || (folder && checkPermission('project.folder_archive',project.isGlobalPermission) === true && !showArchived)
                        || (!folder && checkPermission('project.sprint_archive',project.isGlobalPermission) === true && !showArchived)
                        || (!folder && checkPermission('task.import_tasks',project.isGlobalPermission) === true)
                        || (!folder && checkPermission('task.export_tasks',project.isGlobalPermission) === true)
                    ) && checkPermission('project.project_list',project.isGlobalPermission) === true
                    && (showArchived ? data.deletedStatusKey === 2 : !data.deletedStatusKey)
                ">
                    <template #button>
                        <img src="@/assets/images/svg/menu-dots-bold.svg" alt="dots" class="project__three-dot ml-6px vertical-middle"  :class="{'project-option': clientWidth > 767 && !isOpened, 'project-option-mobile': clientWidth <= 767}" :ref="itemId">
                    </template>

                    <template #options>
                        <template v-if="!showArchived">
                            <DropDownOption v-if="folder && checkPermission('project.project_sprint_create',project.isGlobalPermission) === true" @click="createSprint = true, $refs[itemId]?.click(), $emit('change', {...data, isNewClicked: true })">
                                <div class="d-flex align-items-center project-mobile-desc">
                                    <img :src="listIcon" alt="listIcon" class="mr-10px">
                                    {{$t('Projects.create_new_list')}}
                                </div>
                            </DropDownOption>
                            <DropDownOption v-if="folder ? checkPermission('project.project_folder_name_edit',project.isGlobalPermission) === true : checkPermission('project.project_sprint_name_edit',project.isGlobalPermission) === true" @click="$refs[itemId]?.click(), rename()">
                                <div class="d-flex align-items-center project-mobile-desc">
                                    <img :src="editIcon" alt="editIcon" class="mr-10px">
                                    {{$t('Projects.rename')}}
                                </div>
                            </DropDownOption>
                            <DropDownOption v-if="(folder ? checkPermission('project.folder_archive',project.isGlobalPermission) === true : checkPermission('project.sprint_archive',project.isGlobalPermission) === true) && !showArchived" @click="$refs[itemId]?.click(), showSidebar = true, archive = true">
                                <div class="d-flex align-items-center project-mobile-desc">
                                    <img :src="inventoryIcon" alt="inventoryIcon" class="mr-10px">
                                    {{$t('Projects.archive')}}
                                </div>
                            </DropDownOption>
                            <DropDownOption v-if="!folder && checkPermission('task.import_tasks',project.isGlobalPermission) === true" @click="handleImportClick" @toggle-import-modal="(showImportModal = !val)">
                                <div class="d-flex align-items-center project-mobile-desc">
                                    <img :src="importIcon" alt="importIcon" class="mr-10px">
                                    {{$t('importTaskButton.import_button')}}
                                </div>
                            </DropDownOption>
                            <DropDownOption v-if="!folder && checkPermission('task.export_tasks',project.isGlobalPermission) === true" @click="handleExportClick">
                                <div class="d-flex align-items-center project-mobile-desc">
                                    <img :src="exportIcon" alt="exportIcon" class="mr-10px">
                                    {{$t('importTaskButton.export_button')}}
                                </div>
                            </DropDownOption>
                       
                        </template>
                        <DropDownOption v-if="(folder ? checkPermission('project.folder_restore',project.isGlobalPermission) === true : checkPermission('project.sprint_restore',project.isGlobalPermission) === true) && showArchived == true" @click="$refs[itemId]?.click(), updateItem(0)">
                            <div class="d-flex align-items-center project-mobile-desc">
                                <img :src="inventoryIcon" alt="restoreInventoryIcon" class="mr-10px">
                                {{$t('Projects.restore')}}
                            </div>
                        </DropDownOption>
                        <DropDownOption v-if="(folder ? checkPermission('project.folder_delete',project.isGlobalPermission) === true : checkPermission('project.sprint_delete',project.isGlobalPermission) === true) && checkPermission('project.project_list',project.isGlobalPermission) === true" @click="$refs[itemId]?.click(), showSidebar = true, archive = false">
                            <div class="d-flex align-items-center project-mobile-desc mobile-deleteIcon red">
                                <img :src="deleteIcon" alt="deleteIcon" class="mr-10px">
                                {{$t('Projects.delete')}}
                            </div>
                        </DropDownOption>
                    </template>
                </DropDown>
            </div>
            <div>
                <ImportTaskButton 
                    ref="importTaskRef"
                    :showImportModal="showImportModal"
                    :projectId="project?._id"
                    :taskStatus="project?.taskStatusData"
                    :users="project?.isPrivateSpace ? (project?.AssigneeUserId || []) : (companyUsers || [])"
                    :sprint="sprint"
                    @toggle-import-modal="showImportModal = false"
                />
            </div>
        </div>
        <div v-if="createSprint || renameFolder || renameSprint" class="d-flex align-items-center create__rename-sprintwrapper m3px-auto">
            <SprintFolderInput
                :createSprint="createSprint || renameSprint"
                :createFolder="renameFolder"
                :folder="folder ? {folderId: data.folderId, folderName: data.name} : data.folderId ? {folderId: data.folderId, folderName: data.folderName} : null"
                :item="renameFolder || renameSprint ? data : null"
                :subItems="folder && !renameFolder ? [...(Object.values(data?.sprintsObj || {}))] : subItems"
                @cancel="createSprint = false, renameFolder = false, renameSprint=false"
                @updateData="handleSprintFolderUpdate"
            />
        </div>
        <div v-if="isExpanded && sprints?.length" class="pl-10px">
            <template v-for="subItem in sprints">
                <SubItem
                    v-if="showArchived ? (subItem.deletedStatusKey === 2 || subItem.archiveTaskCount) : (!subItem.deletedStatusKey)"
                    :key="subItem.id"
                    :data="subItem"
                    :subItems="[...(sprints || [])]"
                    :filterFavorites="filterFavorites"
                    :isShowArchived="isShowArchived"
                    @change="toggleSubItem($event)"
                    @changeProject="$emit('changeProject')"
                    @handleSidebarClose="emit('handleSidebarClose')"
                    @updateFolderAndSprint="(data, type) => emit('updateFolderAndSprint', data, type)"
                    @archiveCountChange="(delta) => emit('archiveCountChange', delta)"
                />
            </template>
        </div>

        <ConfirmationSidebar
            v-model="showSidebar"
            :title="`${archive ? $t('Projects.archive') : $t('Projects.delete')}`"
            :message="archive ? $t('conformationmsg.archive') : $t('conformationmsg.delete')"
            :confirmationString="`${archive ? 'archive' : 'delete'}`"
            :acceptButtonClass="archive ? 'btn-primary': 'btn-danger'"
            :acceptButton="`${archive ? $t('Projects.archive') : $t('Projects.delete')}`"
            @confirm="updateItem()"
            displayMode="modal"
            :showSpinner="showSpinner"
        />
    </div>
</template>

<script setup>
// PACKAGES
import { computed, defineComponent, defineEmits, defineProps, inject, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useCustomComposable, useGetterFunctions } from '@/composable';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

// COMPONENTS
import SubItem from './SubItem'
import DropDown from '@/components/molecules/DropDown/DropDown.vue'
import DropDownOption from '@/components/molecules/DropDownOption/DropDownOption.vue'
import SprintFolderInput from '@/components/atom/SprintFolderInput/SprintFolderInput.vue'
import ConfirmationSidebar from "@/components/molecules/ConfirmationSidebar/ConfirmationSidebar.vue"
import Spinner from "@/components/atom/SpinnerComp/SpinnerComp.vue"
import { apiRequest } from '../../../services';
import * as env from '@/config/env';
import { useI18n } from "vue-i18n";
const { t } = useI18n();

// UTILS
const $toast = useToast();
const router = useRouter();
const route = useRoute();
const userId = inject("$userId");
const {showCounts, checkPermission} = useCustomComposable();
const companyId = inject("$companyId");
const {getUser} = useGetterFunctions()
const {getters,commit} = useStore();
const clientWidth = inject("$clientWidth");
const showArchived = inject("showArchivedProjects");
const isOpened = ref(false)
const exportTasks = inject("ExportTaskAsCsv");

const currentCompany = computed(() => getters['settings/selectedCompany']);
const importTaskPermission = currentCompany?.value.planFeature.taskImportPermission;
const exportTaskPermission = currentCompany?.value.planFeature.taskExportPermission;

// IMAGES
const inventoryIcon = require("@/assets/images/svg/inventoryIcon.svg");
const deleteIcon = require("@/assets/images/svg/deleteIcon.svg");
const listIcon = require("@/assets/images/svg/listView.svg");
const folderIcon = require("@/assets/images/folder.png");
const sprintIcon = require("@/assets/images/svg/subtaskicon.svg");
const editIcon = require("@/assets/images/svg/rename.svg");
const filledStar = require("@/assets/images/svg/active-pin.svg");
const blankStar = require("@/assets/images/svg/pin.svg");
const importIcon = require("@/assets/images/svg/importIcon.svg");
const exportIcon = require("@/assets/images/svg/exportIcon.svg");

defineComponent({
    name: "sub-item",

    components: {
        SubItem,
        DropDown,
        DropDownOption,
        SprintFolderInput,
        ConfirmationSidebar,
    }
})

const emit = defineEmits(['change', 'changeProject',"updateFolderAndSprint","handleSidebarClose", "archiveCountChange"]);

const props = defineProps({
    data: {
        type: Object,
        required: true
    },
    folder: {
        type: Boolean,
        default: false
    },
    filterFavorites: {
        type: Boolean,
        default: false
    },
    isExpanded: {
        type: Boolean,
        default: false
    },
    subItems: {
        type: Array,
        default: () => []
    },
    isShowArchived: {
        type: Boolean,
        default: false
    }
})

const companyUsers = computed(() => {
    return getters["settings/companyUsers"]?.map((x) => x.userId)
})

const handleImportClick = () => {
    if (!importTaskPermission) {
        $toast.error(t("Toast.Upgrade_for_import"), {position: "top-right"});
        return;
    }
    showImportModal.value = true;
};

const handleExportClick = () => {
    if (!exportTaskPermission) {
        $toast.error(t("Toast.Upgrade_for_export"), {position: "top-right"});
        return;
    }
    exportTasks({ sprintId: sprint?.value._id, projectId: project?._id, fileName: (`${project?.value.ProjectCode}_${sprint?.value.name}` || 'Project_SprintData')});
};

const sprints = computed(() => {
    const sprintObject = props?.data?.archivedSprintList || props?.data?.sprintsObj || {};
    return sortPinnedFirst(Object.values(sprintObject));
});

const itemId = computed(() => {
    return props.folder ? props.data.folderId : props.data.id;
})

const sprint = computed(() => {
    return props.data;
})

const importTaskRef = ref(null);
const showImportModal = ref(false);
const spinner = ref(false);
const archive = ref(false);
const showSpinner = ref(false);
const showSidebar = ref(false);
const createSprint = ref(false);
const renameFolder = ref(false);
const renameSprint = ref(false);
const project = inject("selectedProject");
const localFavourite = ref(false);

function isPinned(item = {}) {
    return Boolean(item?.favouriteTasks?.some((x) => x.userId === userId.value));
}

function getCreatedAtTime(item = {}) {
    const createdAt = item?.createdAt;

    if (createdAt?.seconds) {
        return createdAt.seconds * 1000;
    }

    if (typeof createdAt === 'number') {
        return createdAt > 10000000000 ? createdAt : createdAt * 1000;
    }

    const time = new Date(createdAt || 0).getTime();
    return Number.isFinite(time) ? time : 0;
}

function sortPinnedFirst(items = []) {
    return [...items].sort((a, b) => {
        const pinDiff = Number(isPinned(b)) - Number(isPinned(a));
        if (pinDiff !== 0) return pinDiff;
        return getCreatedAtTime(b) - getCreatedAtTime(a);
    });
}

function getUpdatedFavouriteTasks(tasks = [], shouldPin = false) {
    const currentTasks = Array.isArray(tasks) ? tasks.filter(Boolean) : [];
    const withoutCurrentUser = currentTasks.filter((x) => x.userId !== userId.value);

    if (shouldPin) {
        return [...withoutCurrentUser, { userId: userId.value }];
    }

    return withoutCurrentUser;
}

function getArchiveCountDelta(previousDeletedStatusKey, nextDeletedStatusKey) {
    const wasArchived = previousDeletedStatusKey === 2;
    const isArchived = nextDeletedStatusKey === 2;

    if (!wasArchived && isArchived) return 1;
    if (wasArchived && !isArchived) return -1;
    return 0;
}

watch(
    () => props.data?.favouriteTasks,
    (val) => {
        localFavourite.value = !!val?.some(
            (x) => x.userId === userId.value
        );
    },
    { immediate: true, deep: true }
);
const companyOwner = computed(() => getters["settings/companyOwnerDetail"])
function getUserData() {
    const user = getUser(userId.value);
    const userData = {
        id: user.id,
        Employee_Name: user.Employee_Name,
        companyOwnerId: companyOwner.value.userId,
    }

    return userData;
}

function changeRoute() {
    let tab = route.query?.tab;
    if(!project.value?.ProjectRequiredComponent?.find((x) => x.keyName === route.query?.tab)) {
        let viewFind = project.value?.ProjectRequiredComponent?.find((e) => e.setAsDefault) || project.value?.ProjectRequiredComponent?.find((e) => e.viewStatus) || project.value?.ProjectRequiredComponent[0];
        tab = viewFind ? viewFind?.keyName :"ProjectListView";
    }
    if(props.data.folderId && props.data.sprintsObj) {
        router.push({
            name: "ProjectFolder",
            params: {
                id: project.value._id,
                folderId: props.data.folderId
            },
            query: {
                ...route.query,
                tab
            }
        })
    } else {
        if(props.data.folderId) {
            router.push({
                name: "ProjectFolderSprint",
                params: {
                    id: project.value._id,
                    folderId: props.data.folderId,
                    sprintId: props.data.id ? props.data.id : props.data._id
                },
                query: {
                    ...route.query,
                    tab
                }
            })
        } else {
            router.push({
                name: "ProjectSprint",
                params: {
                    id: project.value._id,
                    sprintId: props.data.id ? props.data.id : props.data._id
                },
                query: {
                    ...route.query,
                    tab
                }
            })
        }
    }
    emit('handleSidebarClose')
}

function toggleSubItem(data) {
    Object.keys(data.sprintsObj).forEach((key) => {
        if(data.sprintsObj[key].id === data.id) {
            data.sprintsObj[key].isExpanded = !data.sprintsObj[key].isExpanded;
        } else {
            data.sprintsObj[key].isExpanded = false;
        }
    })
}

function rename() {
    if(props.folder) {
        renameFolder.value = true;
        renameSprint.value = false;
    } else {
        renameFolder.value = false;
        renameSprint.value = true;
    }
}

function handleSprintFolderUpdate(data, type) {
    createSprint.value = false;
    renameFolder.value = false;
    renameSprint.value = false;

    emit("updateFolderAndSprint", data, type);
}

function updateItem(value = null) {
    showSpinner.value = true;

    let obj = {};
    let updatedValue = '';
    const previousDeletedStatusKey = props.data?.deletedStatusKey;
    if(props.folder) {
        obj.$set = { deletedStatusKey: value !== null ? value : archive.value ? 2 : 1}
        updatedValue = value !== null ? value : archive.value ? 2 : 1
    } else {
        obj.$set = {deletedStatusKey: value !== null ? value : archive.value ? 2 : 1};
        updatedValue = value !== null ? value : archive.value ? 2 : 1
    }

    const userData = getUserData();

    const axiosData = {
        type: !props.folder ? "updateSprint" : "updateFolder",
        companyId: companyId.value,
        projectId: project.value._id,
        folderId: props.data.folderId || null,
        updateObject: {
            ...obj
        },
        updatedValueDeleteStatusKey: updatedValue,
        userData,
        sprintName: !props.folder ? props.data.name : null,
        projectData: {
            id: project.value._id,
            ProjectName: project.value.ProjectName
        },
        folderName: props.data.name,
    }

    if(!props.folder && props.item?.folderId) {
        axiosData.folderName = props.item.folderName
    }
    
    if(props.folder) {
        axiosData.sprints = sprints.value?.filter((x) => !x.deletedStatusKey || x.deletedStatusKey === 6)?.map((x) => x.id)
    }
    let reqUrl = env.SPRINT+'/'+itemId.value;
    if (props.data.folderId) {
        reqUrl = env.FOLDER+'/'+itemId.value;
    }
    apiRequest("patch", reqUrl, axiosData)
    .then((res) => {
        if(!res.data.status) {
            showSpinner.value = false;
            $toast.error(t(`Toast.something_went_wrong`), {position: "top-right"})
            return;
        }
        if (props.folder) {
            commit("projectData/mutateFolders",{op:'modified',data:{...res?.data?.data}});
        }
        else{
            commit("projectData/mutateSprints",{op:'modified',data:{...res?.data?.data}});
        }
        if (res?.data?.data) {
            let type;
            if (props.folder) {
                type = 'Folder';
            } else {
                type = 'Sprint';
            }
            emit("updateFolderAndSprint",res?.data?.data,type);
            emit("archiveCountChange", getArchiveCountDelta(previousDeletedStatusKey, updatedValue));
        }
        $toast.success(t(`Toast.${props.folder ? 'Folder' : 'Sprint'} ${value !== null ? 'restored' : archive.value ? 'archived' : 'deleted'} successfully`), {position: "top-right"})
        showSidebar.value = false;
        showSpinner.value = false;
        archive.value = false;
    })
    .catch((error) => {
        archive.value = false;
        showSidebar.value = false;
        showSpinner.value = false;
        $toast.error(t(`Toast.something_went_wrong`), {position: "top-right"})
        console.error("ERROR in updateItem: ", error);
    })
}

function markFavourite() {
    spinner.value = true;
    const userData = getUserData();
    const previousFavouriteTasks = Array.isArray(props.data?.favouriteTasks) ? [...props.data.favouriteTasks] : [];
    const fav = previousFavouriteTasks.some((x) => x.userId === userId.value);
    const nextFavourite = !fav;
    const optimisticData = {
        ...props.data,
        favouriteTasks: getUpdatedFavouriteTasks(previousFavouriteTasks, nextFavourite)
    };
    const key = fav ? "$pull" : "$addToSet";
    localFavourite.value = nextFavourite;
    emit("updateFolderAndSprint", optimisticData, 'Sprint');

    apiRequest("put", `/api/v1/${env.PROJECTSPRINTUPDATE}/${props.data?.id ? props.data?.id : props.data?._id}`, {updateObject: { favouriteTasks: { userId: userId.value } },key: key}).then((results) => {
        spinner.value = false;
        const updatedSprint = results?.data?.data || results?.data || optimisticData;
        emit("updateFolderAndSprint",updatedSprint,'Sprint');
        $toast.success(t(`Toast.${nextFavourite ? "Added_to_favourite" : "Removed_from_favourite"}`), {position: "top-right"});

        // Call history API
        const axiosData = {
            "type": "project",
            "companyId": companyId.value,
            "projectId": project.value._id,
            "taskId": null,
            "object": {
                "sprintId": props.data.id,
                "key": "Create_Sprint",
                "message": `<b>${userData.Employee_Name}</b> has set <b>${props.data.name}</b> sprint as favorite in <b>${project.value.ProjectName}</b> project.`
            },
            "userData": userData
        };
        apiRequest("post", env.HANDLE_HISTORY, axiosData).then((result) => {
            if(result.data.status) {
                console.info(result.data.statusText)
            }
        });
    }).catch((error)=>{
        localFavourite.value = fav;
        emit("updateFolderAndSprint", {
            ...props.data,
            favouriteTasks: previousFavouriteTasks
        }, 'Sprint');
        spinner.value = false;
        console.error(error)
    })

}
</script>

<style>
.project-favourite-pin {
    width: 15px;
    height: 15px;
}
.list-spinner .spinner {
    width: 10px !important;
    height: 10px !important;
    left: -5px;
}
.create__rename-sprintwrapper{
    padding: 0px 10px 0px 32px;
}
.drop__arrow-div{
    min-width: 10px;
    left: 10px;
}
</style>
